import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { anySerializer } from '../composables/any-serializer';
import type { FeatureModel } from '../models/feature.model';

export const useFeaturesStore = defineStore('features', () => {
  const features = useLocalStorage<Record<string, FeatureModel>>(
    'account/features',
    {},
    {
      serializer: anySerializer,
    },
  );

  function addAcountFeatures(accountfeatures: Record<string, FeatureModel>) {
    features.value = { ...features.value, ...accountfeatures };
  }

  function $reset() {
    features.value = {};
  }

  return { features, addAcountFeatures, $reset };
});
